// extracted by mini-css-extract-plugin
export var animationContainer = "_m1-0";
export var footer = "_m1-1";
export var gray = "_m1-2";
export var lineItem = "_m1-3";
export var lineItemImage = "_m1-4";
export var lineItemInfo = "_m1-5";
export var lineItemText = "_m1-6";
export var lineItems = "_m1-7";
export var modalContent = "_m1-8";
export var options = "_m1-9";
export var orderName = "_m1-a";
export var refundAmount = "_m1-b";